<template>
  <main class="main cart-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="title empty-desc" v-if="!cartContents.length">
            {{ $t('Cart is empty!') }}
          </div>
          <div class="left" v-if="cartContents.length">
            <div class="desc medium">
              <b>{{ $t('Products') }}</b>
            </div>
            <div class="product-table">
              <div class="table">
                <table>
                  <tbody>
                    <tr v-for="(item, i) in cartContents" :key="i">
                      <td>
                        <div class="td-wrapper">
                          <div class="preview">
                            <div v-if="item.item.product_type == 'doc'" class="doc-img">
                              <img src='./../images/doc.svg' class="img"/>
                            </div>
                            <img v-else :src="imgDomain + item.item.doc_url" class="img"/>
                          </div>
                          <div class="text">
                            <div class="desc name">{{item.item.title}}</div>
                            <div class="desc price">
                             <b>{{item.item.price}} <span class="currency">{{$parent.currency}}</span></b>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="td-wrapper">
                          <div class="delete" @click="removeFromCart(item)">
                            <img src="./../images/bin.svg" class="img"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="desc">{{ $t('Total') }}:</div>
              <div class="title">{{totalSum}} <span class="currency">{{$parent.currency}}</span></div>
            </div>
          </div>
          <div class="right" v-if="cartContents.length">
            <div class="title regular">{{ $t('Billing information') }}</div>
            <div class="wrapper">
              <div class="input-container">
                <div class="desc"><span class="red">*</span>{{ $t('First name') }}:</div>
                <input type="text" :placeholder="$t('First name')" v-model="name"/>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>{{ $t('Last name') }}:</div>
                <input type="text" :placeholder="$t('Last name')" v-model="surname"/>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>{{ $t('Phone') }}:</div>
                <input type="tel" :placeholder="$t('Phone')" v-model="phone"/>
              </div>
              <div class="input-container" v-if="countryOptions && countryOptions.length">
                <div class="desc"><span class="red">*</span>{{ $t('Country') }}:</div>
                <select v-model="country">
                  <option value="" selected disabled>{{ $t('Country') }}</option>
                  <option v-for="item in countryOptions" :key="item.id">{{item.title}}</option>
                </select>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>{{ $t('City') }}:</div>
                <input type="text" :placeholder="$t('City')" v-model="city"/>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>{{ $t('Address') }}:</div>
                <input type="text" :placeholder="$t('Address')" v-model="address"/>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>{{ $t('Post Code') }}:</div>
                <input type="text" :placeholder="$t('Post Code')" v-model="postCode"/>
              </div>
              <div class="input-container input-container-checkbox">
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input type="checkbox" name="terms" v-model="terms"/>
                      <div class="checkbox"></div>
                      <span class="title">{{ $t('I agree with') }} </span>
                      <a @click="$parent.goToPage('privacy')" class="title">{{ $t('privacy policy') }} </a>
                      <span class="title"> {{ $t('and') }} </span>
                      <a @click="$parent.goToPage('terms')" class="title">{{ $t('terms and conditions') }}</a>
                    </div>
                  </label>
                </div>
              </div>
              <div class="buttons">
                <button :class="['button blue', {'disabled': !requiredFieldsAreFilled}]" @click="submit">
                  <span>[ {{ $t('Checkout') }} ]</span>
                </button>
                <ul class="methods">
                  <li class="methods__item">
                    <img src='./../images/methods/mc.svg' class="img"/>
                  </li>
                  <li class="methods__item">
                    <img src='./../images/methods/visa.svg' class="img"/>
                  </li>
                  <li class="methods__item">
                    <img src='./../images/methods/3ds.svg' class="img"/>
                  </li>
                </ul>
                <button :class="['button', {'disabled': !requiredFieldsAreFilled}]" style="margin-top: 10px; width: 100%;" @click="submit">
                  <img
                    v-if="blikImage"
                    :src="blikImage"
                    alt="Blik"
                    style="max-height: 30px; width: auto;"
                  />
                  <span v-else>BLIK</span>
                </button>
                <div v-if="$parent.settings && $parent.settings.visitor_country === 'PL'" style="margin-top: 4px; text-align: center;">
                  <a
                    href="https://www.igoriacard.com/regulamin-i-oplaty/regulamin-BLIK/"
                    target="_blank"
                    class="desc blik-link"
                  >{{ $t('BLIK Regulations') }}</a>
                </div>
              </div>
              <!-- <transition name="fade">
                <div :class="['desc', {'error-desc red': redAmount}]">Minimum checkout amount is 5 {{$parent.currency}}</div>
              </transition> -->
              <transition name="fade">
                <div v-if="$parent.error" class="desc error-desc red">{{$parent.error}}</div>
              </transition>
            </div>
          </div>
        </div>
      </section>
      <div class="section nav-bottom-section">
        <Nav />
      </div>
    </div>
  </main>
</template>
<script>
import Nav from '../components/Nav.vue'

export default {
  name: 'Cart',
  props: ['categories'],
  components: {
    Nav
  },
  data: function() {
    return {
      imgDomain: '',
      totalSum: '',
      cartContents: '',
      countryOptions: [],
      countryOptionsId: [],
      name: '',
      surname: '',
      phone: '',
      country: '',
      countryId: '',
      city: '',
      address: '',
      postCode: '',
      terms: false,
      redAmount: false
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getCartContents();
    this.getCounties();
    this.getProfile();
  },
  watch: {
    country: function() {
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.country === this.countryOptions[i].title) {
          this.countryId = this.countryOptions[i].id
          break;
        }
      }
      this.countryId
    },
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname  && this.phone && 
        this.country && 
        this.city && this.address  
        && this.postCode && this.terms 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
    blikImage() {
      const methods = this.$parent && this.$parent.settings && Array.isArray(this.$parent.settings.payment_methods)
        ? this.$parent.settings.payment_methods
        : [];
      const blik = methods.find(m => m && m.code === 'blik');
      return blik ? blik.image : null;
    }
  },
  methods: {
    getProfile() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
        console.log(res)
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.email = res.data.email;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    getCounties() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
      .then((res) => {
        this.countryOptions = res.data.payload;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    submit() {
      let data = {
        "name": this.name,
        "surname": this.surname,
        "phone": this.phone,
        "country": this.countryId,
        "city": this.city,
        "address": this.address,
        "postCode": this.postCode
      }
      this.$http.post(process.env.VUE_APP_API + 'orders/checkout', data)
      .then((res) => {
          console.log(res);
          window.location = res.data.redirect_url;
      })
      .catch((res) => {
        if (res.response.data.status == 'MIN_AMOUNT_ERROR') {
          this.redAmount = true;
        } else {
          this.redAmount = false;
          this.$emit('setError', res.response.data.message)
        }
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    crealCart() {
      this.$http.post(process.env.VUE_APP_API + 'cart/clear')
      .then((res) => {
        this.$parent.getCartContents();
        this.cartContents = res.data.cart;
        this.totalSum = res.data.cart.totalAmount
      })
      .catch((res) => {
        console.log(res);
      })
    },
    removeFromCart(item) {
      let param = {
        'id' : item.item_id
      } 
      this.$http.post(process.env.VUE_APP_API + 'cart/remove', param)
      .then((res) => {
        this.$parent.getCartContents();
        this.cartContents = res.data.cart.payload;
        this.totalSum = res.data.cart.totalAmount;
      })
      .catch((res) => {
        console.log(res);
      })
    },
    getCartContents() {
      this.$http.get(process.env.VUE_APP_API + 'cart/contents')
      .then((res) => {
        this.cartContents = res.data.cart.payload;
        this.totalSum = res.data.cart.totalAmount
      })
      .catch((res) => {
        console.log(res);
      })
    },
    toOrder() {
      this.$router.push({ path: '/order' })
    }
  }
}
</script>

<style scoped>
.blik-link {
  text-decoration: none;
  font-size: 11px;
}

.blik-link:hover {
  text-decoration: underline;
}
</style>